import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as contentblockActions from '../actions/events.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { EventsService } from '../../services';

@Injectable()
export class EventsEffects {
  private actions$ = inject(Actions);
  private PageService = inject(EventsService);


  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadEvents),
      switchMap(({ profileId, skip, take }) =>
        this.PageService.getEvents(profileId || 0, skip, take).pipe(
          map(events => contentblockActions.LoadEventsSuccess({ events })),
          catchError(error => of(contentblockActions.LoadEventsFail({ error })))
        )
      )
    );
  });

  LoadOverview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadEventsOverview),
      switchMap(({ profileId, skip, take }) =>
        this.PageService.getEvents(profileId || 0, skip, take).pipe(
          map(events => contentblockActions.LoadEventsOverviewSuccess({ events })),
          catchError(error => of(contentblockActions.LoadEventsOverviewFail({ error })))
        )
      )
    );
  });

  LoadEventDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadEventDetail),
      switchMap(({ id }) =>
        this.PageService.getEventDetail(id).pipe(
          map(event => contentblockActions.LoadEventDetailSuccess({ event })),
          catchError(error => of(contentblockActions.LoadEventDetailFail({ error })))
        )
      )
    );
  });
}
